import { render, staticRenderFns } from "./AddEmergencyContact.vue?vue&type=template&id=acfa5890&scoped=true"
import script from "./AddEmergencyContact.vue?vue&type=script&lang=js"
export * from "./AddEmergencyContact.vue?vue&type=script&lang=js"
import style0 from "./AddEmergencyContact.vue?vue&type=style&index=0&id=acfa5890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfa5890",
  null
  
)

export default component.exports